import { ApiResponse } from '@/types/common';
import { RegistroEntrenoDto } from '@/types/asistencia';
import { BaseService } from './BaseService';

/**
 * Servicio para la gestión de asistencia a entrenamientos
 */
class AsistenciaService extends BaseService {
  constructor() {
    super('/registros-entreno');
  }

  /**
   * Obtiene los registros de asistencia para una fecha específica
   * @param fecha Fecha en formato YYYY-MM-DD
   * @returns Promise con los registros de asistencia
   */
  async obtenerRegistrosPorFecha(fecha: string): Promise<ApiResponse<RegistroEntrenoDto[]>> {
    const response = await fetch(`${this.baseURL}${this.endpoint}/mobile/fecha/${fecha}`, {
      method: 'GET',
      headers: this.getHeaders()
    });
    
    return this.handleResponse<ApiResponse<RegistroEntrenoDto[]>>(response);
  }

  /**
   * Guarda los registros de asistencia para una fecha específica
   * @param fecha Fecha en formato YYYY-MM-DD
   * @param registros Mapa con jugadorId y asistencia
   * @returns Promise con los registros guardados
   */
  async guardarRegistrosAsistencia(
    fecha: string, 
    registros: Record<number, boolean>
  ): Promise<ApiResponse<RegistroEntrenoDto[]>> {
    const response = await fetch(`${this.baseURL}${this.endpoint}/mobile/fecha/${fecha}`, {
      method: 'POST',
      headers: this.getHeaders(),
      body: JSON.stringify(registros)
    });
    
    return this.handleResponse<ApiResponse<RegistroEntrenoDto[]>>(response);
  }
}

export const asistenciaService = new AsistenciaService();